import { CATALOG_TYPE_UNCATEGORIZED } from '../types/catalogTypes';
import { CATALOG_STATUS_ACTIVE } from '../statuses/catalogStatus';

export const UNCATEGORIZED_CATALOG = {
  catalogId: CATALOG_TYPE_UNCATEGORIZED,
  catalogType: CATALOG_TYPE_UNCATEGORIZED,
  catalogStatus: CATALOG_STATUS_ACTIVE,
  catalogName: 'Uncategorised Items',
};
